// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f1954320","24":"9d8cf4fa","394":"3a4d0efc","752":"cbcfe279","886":"804ef51d"}[chunkId] + ".chunk.js";
};